export default class UIModel {
  /**
   * UIModel saves mute state to LocalStorage via utils/Settings
   */

  constructor({ settings }) {
    this.settings = settings;
    this.paused = false;
    this.onAudioIsChanged = new Phaser.Signal();
    this.onPauseIsChanged = new Phaser.Signal();
  }

  /**
   * AUDIO
   */
  toggleAudio() {
    const result = this.settings.toggleAudio();
    if (result.isMuted) {
    }
    this.onAudioIsChanged.dispatch(result);
  }
  getAudio() {
    return this.settings.getAudio();
  }
  getIsMuted() {
    return this.settings.getIsMuted();
  }

  /**
   * Pause
   */

  setPaused(value) {
    this.paused = value;
    this.onPauseIsChanged.dispatch({ paused: this.paused, fromUI: true });
  }

  destroy() {
    this.onAudioIsChanged.forget();
    this.onAudioIsChanged.dispose();
    this.onAudioIsChanged.removeAll();
    this.onPauseIsChanged.forget();
    this.onPauseIsChanged.dispose();
    this.onPauseIsChanged.removeAll();
    super.destroy();
  }
}
